/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerieSerieidLangs200,
  GetApiV1SerieSerieidLangs401,
  GetApiV1SerieSerieidLangs404,
  GetApiV1SerieSerieidLangs500,
  GetApiV1SerieSerieidLangsPathParams,
  GetApiV1SerieSerieidLangsQueryParams,
  GetApiV1SerieSerieidLangsQueryResponse,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangs.ts";
import { serieLangViewModelPaginatedResponseSchema } from "../serieLangViewModelPaginatedResponseSchema.ts";

export const getApiV1SerieSerieidLangsPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerieSerieidLangsPathParams>;

export const getApiV1SerieSerieidLangsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1SerieSerieidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerieSerieidLangs200Schema = z.lazy(
  () => serieLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1SerieSerieidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerieSerieidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerieSerieidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerieSerieidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangs500>;

export const getApiV1SerieSerieidLangsQueryResponseSchema = z.lazy(
  () => getApiV1SerieSerieidLangs200Schema,
) as unknown as ToZod<GetApiV1SerieSerieidLangsQueryResponse>;
